export default "__VITE_ASSET__BYEkDPul__"